module.exports = __webpack_public_path__ + "assets/close.b0eee70e.svg";